import { Scenario, Category, TestResult } from '../types';
import { ToastType } from '../components/Toast';

export const handleStatusChange = (
  status: string,
  currentScenario: Scenario,
  currentCategory: string,
  categories: Category[],
  onScenarioSelect: (scenario: Scenario) => void,
  onStatusChange: (status: string) => void,
  onCategoriesUpdate: (categories: Category[]) => void,
  showToast: (message: string, type: ToastType) => void
) => {
  if (currentScenario) {
    const updatedScenario = { ...currentScenario, Status: status };
    onScenarioSelect(updatedScenario);
    onStatusChange(status);

    const updatedCategories = categories.map(category => {
      if (category.name === currentCategory) {
        return {
          ...category,
          scenarios: category.scenarios.map(scenario =>
            scenario['ID testu'] === currentScenario['ID testu']
              ? { ...scenario, Status: status }
              : scenario
          )
        };
      }
      return category;
    });

    onCategoriesUpdate(updatedCategories);
  }
};

export const handleBulkStatusChange = async (
  status: string,
  currentCategory: string,
  categories: Category[],
  onCategoriesUpdate: (categories: Category[]) => void,
  currentTest: TestResult
): Promise<TestResult> => {
  if (!currentCategory) return Promise.reject('Brak wybranej kategorii');
  
  const updatedCategories = categories.map(category => {
    if (category.name === currentCategory) {
      return {
        ...category,
        scenarios: category.scenarios.map(scenario => ({
          ...scenario,
          Status: status
        }))
      };
    }
    return category;
  });

  onCategoriesUpdate(updatedCategories);

  // Aktualizuj wyniki testów
  const updatedTest = {
    ...currentTest,
    scenarioResults: {
      ...currentTest.scenarioResults,
      ...updatedCategories
        .find(cat => cat.name === currentCategory)
        ?.scenarios.reduce((acc, scenario) => ({
          ...acc,
          [scenario['ID testu']]: {
            Status: status,
            Notes: scenario.Notes || ''
          }
        }), {})
    }
  };

  return Promise.resolve(updatedTest);
}; 